// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e69d4757","239":"07645d7c","455":"59b1a165","762":"38a8ea28"}[chunkId] + ".chunk.js";
};